var $ = jQuery;

$(document).ready(function () {

    /**
     * *Project Click
     */
    $('.project').on('click', function () {
        // Id from project
        var project_id = $(this).attr('ID');

        // html for  the view
        var project = $("div").find("[data-project='" + project_id + "']"); 
        var project_content = project.html()

        // load project content on view
        $('#project-view').find('#view-content').html(project_content);
        $('#project-view').find('#view-content').data("actual", project_id);

        // !Start statt
        $('#view-next').find('span').html('n&auml;chstes')

        // Open after loaded content
        $('#project-view').addClass('open');
        $('#all-projects').addClass('open');
        // !shadow
        $('.shadow').addClass('open')
        $('.shadow-extra').addClass('open')

        $('#all-projects').removeClass('withoutPadding');
        $('.project').addClass('open');

        // !Hidden bottom Info
        $('#info-seite').addClass('superHidden')

        // !Scroll to the Top
        if ( $('#project-view').hasClass('open') && $(document).scrollTop() != 0 ) {
            
            $('html,body').animate({
                scrollTop: 0
            }, 500)
        } else {
            $('html,body').animate({
                scrollTop: 0
            }, 100)
            
        }
    })

    /**
     * * Project view close
     */
    $('#view-close').find('svg').on('click', function () {
        // load project content on view
        $('#project-view').find('#view-content').html("");
        
        // Close after loaded content
        $('#project-view').removeClass('open');
        $('#all-projects').removeClass('open');
        // !shadow
        $('.shadow').removeClass('open')
        $('.shadow-extra').removeClass('open')

        $('#all-projects').addClass('withoutPadding');
        $('.project').removeClass('open');

        // !Start statt
        $('#view-next').find('span').html('n&auml;chstes')

        // !Show bottom Info
        $('#info-seite').removeClass('superHidden')

        // !Scroll to the Top
        if ($('#project-view').hasClass('open') && $(document).scrollTop() != 0 ) {
            
            $('html,body').animate({
                scrollTop: 0
            }, 1000)
        } else {
            $('html,body').animate({
                scrollTop: 0
            }, 100)
            
        }
    })

    /**
     * * Next Project
     */

    $('#view-next').find('svg').on('click', function () {
        var view = $('#project-view').find('#view-content')
        var actual_id = view.data("actual");
        if (typeof (actual_id) == 'undefined') {
            actual_id = $('#all-projects').find('.project-content').last().data('project')
        }
        // var project = $("div").find("[data-project='" + actual_id + "']"); 
        var project = $("div").find("[id='" + actual_id + "']"); 
        var next_id = project.nextAll('.project').slice(0, 1).attr('ID')

        // !Start statt
        $('#view-next').find('span').html('n&auml;chstes')

        // !html for  the view
        if (typeof next_id == 'undefined') {
            var project_content = $('.project-content').first().html()
            next_id = $('.project-content').first().data('project')

        } else {   
            var project_content = $("div").find("[data-project='" + next_id + "']"); 
            project_content = project_content.html()
        }
        

        // !load project content on view
        $('#project-view').find('#view-content').html(project_content);
        $('#project-view').find('#view-content').data("actual", next_id);

        // !Scroll to the Top
        if ($('#project-view').hasClass('open') && $(document).scrollTop() != 0 ) {
            
            $('html,body').animate({
                scrollTop: 0
            }, 1000)
        } else {
            $('html,body').animate({
                scrollTop: 0
            }, 100)
            
        }
    })

    /**
     * *Line Resize
     */
    function resizeLine() {
        let width = $('.line').width()
        let svg_width = $('header').find('svg').width() * 0.85

        
        let def_width = width - svg_width;
        $('.line').css({
        'padding-left': svg_width,
        'z-index': 600
        // 'left': svg_width
        }) 
        $('#Ebene_1').removeClass('color')

    }
    resizeLine()

    /**
     * * Header Height padding all projects
     */
    function headerPadding() {
        var header_height = $("header").height();
        var header_height_out = $("header").outerHeight();
        var font_size = parseInt($('html').css('font-size'));
        var font_size_double = font_size * 1.8;
        var close_ausstellung_height = $('#close-austellung').find('svg').height()
        var plus_mobile_height = $('#plus_mobile').height()
        var height = close_ausstellung_height
        console.log(height)
        if ($(window).width() < 900) {
            height = plus_mobile_height
        }
        // !Next/close arrow like head4r close svg
        $('#view-next').find('svg').css({ 'height': height });
        $('#view-close').find('svg').css({ 'height': height });
        
        if ($(window).width() < 900) {
            $('#plus_infos').css({ 'height': height });
        } else {
            $('#plus_infos').css({ 'height': height + font_size});
            
        }
        // !Project Views
        $('#project-view').css({ 'padding-top': header_height + font_size_double });
        // $('#view-next').css({ 'padding-top': header_height + font_size_double });
        $('#all-projects').css({ 'padding-top': header_height + font_size_double });
        $('.main-vortrage').css({ 'padding-top': header_height + font_size_double });

        // !Info Seite height
        $('#info-seite').css({ 'height': header_height_out})
        
        // !Datenschutz
        $('#main-daten').css({ 'padding-top': header_height + font_size_double })
        // !Mobile Menu
        $('#menu-mobile').find('div').each(function () {
            $(this).css({'height':header_height})
        })

        // !Info min height
        var min_height = $(window).height() - ( parseInt( $('#view-arrows').height() ) * 2 )  - header_height
        $('#view-content').css({'min-height': min_height})
        
    }

    headerPadding()

    /**
     * *footer padding for the all projects
     */
    function footerPadding() {
        var footer_height = $("footer").height()
        var font_size = parseInt($('html').css('font-size'));
        var font_size_double = font_size * 3;
        $('#all-projects').css({ 'padding-bottom': footer_height + font_size_double});
    }

    footerPadding()

    /**
    * * Plus Mobile
    */
    $('#plus_mobile').on('click', function () {
        $(this).find('.vert').toggle();
        $('#menu-mobile').toggleClass('open');
    });

    var scrollAnimating = false
    /**
     * * All projects scroll when open
     */
    var last_scroll = 0;
    _preventEvent = false;
    $('#all-projects').on('scroll', function (e) {
        if (!_preventEvent_document) {
            
            if ($(this).hasClass('open') && $(window).width() > 900) {
                _preventEvent = true;
                var scrolled_or = $(this).scrollTop()
                var document_scrolled = $(document).scrollTop()
              
                if (last_scroll > scrolled_or) {
                    // sube
                    scrolled = last_scroll - scrolled_or
                    scrolled = document_scrolled - scrolled
                    $(document).scrollTop(scrolled)
                } else {
                    // baja
                    scrolled = scrolled_or - last_scroll
                    scrolled = document_scrolled + scrolled
        
                    $(document).scrollTop(scrolled)
                }
                last_scroll = scrolled_or
            } 
        } else {
            _preventEvent_document = false
        }
    })

    /**
     * * Document scroll when  view open
     */
    var last_scroll_or = 0;
    _preventEvent_document = false;

    $(document).on('scroll', function () {
        if (!_preventEvent) {
            
            if ($('#project-view').hasClass('open') && $(window).width() > 900) {
                _preventEvent_document = true
                var scrolled_or = $(this).scrollTop()
                var document_scrolled = $('#all-projects').scrollTop()
              
                if (last_scroll_or > scrolled_or) {
                    // sube
                    scrolled = last_scroll_or - scrolled_or
                    scrolled = document_scrolled - scrolled
                    $('#all-projects').scrollTop(scrolled)
    
                } else {
                    // baja
                    scrolled = scrolled_or - last_scroll_or
                    scrolled = document_scrolled + scrolled
        
                    $('#all-projects').scrollTop(scrolled)
                }
                last_scroll_or = scrolled_or
            }
        } else {
            _preventEvent = false
        }
    })

    /**
     * * X bei Ausstellung
     */
    $('#close-austellung').find('svg').on('click', function () {
        // location('/')
        window.location.href = home.url;
    })
    $('.close2').find('svg').on('click', function () {
        // location('/')
        window.location.href = home.url;
    })
    /**
   * * Logo Link
   */

    $('#Ebene_1').on('click', function () {
        window.location.href = home.url;
    })

    /**
     * * Pop-Up plus click
     */
    $('#plus_infos').on('click', function () {
        var header_height = $("header").height();
        var font_size = parseInt($('html').css('font-size'));
        var font_size_double = font_size * 1.8;

        // !Toggle
        // $('#info-seite').toggleClass('open')

        // !Padding
        // if ($('#info-seite').hasClass('open')) {
        //     $('#info-seite').css({'padding-top': header_height + font_size_double })
        //     $('#info-seite-plus').css({'top': header_height + font_size_double })
        //     disableBodyScroll($('#info-seite').get(0))
            
        // } else {
        //     $('#info-seite').css({'padding-top': '' })
        //     $('#info-seite-plus').css({'top': font_size })
        //     bodyScrollLock.clearAllBodyScrollLocks();
        // }

        // !Start statt
        $('#view-next').find('span').html('Start')

        // !Info
        var project_content = $('#info-seite-content').html()
        $('#project-view').find('#view-content').html(project_content);

        // Open after loaded content
        $('#project-view').addClass('open');
        $('#all-projects').addClass('open');
        // !shadow
        $('.shadow').addClass('open')
        $('.shadow-extra').addClass('open')

        $('#all-projects').removeClass('withoutPadding');
        $('.project').addClass('open');

        // !Hidden bottom Info
        $('#info-seite').addClass('superHidden')

        // !Scroll to the Top
        if ( $('#project-view').hasClass('open') && $(document).scrollTop() != 0 ) {
            
            $('html,body').animate({
                scrollTop: 0
            }, 500)
        } else {
            $('html,body').animate({
                scrollTop: 0
            }, 100)
            
        }
    })

    /**
     * * Vorträge videos
     */
    $('.play-vortrag').prev('svg').on('click', function () {
        var parent_vortrag = $(this).parents('.vortrag-thumbnail')
        $(".einbett").removeClass('open')
        parent_vortrag.find(".einbett").toggleClass('open')
    })
    
    $('.play-vortrag').prev('svg').hover(function () {
        $(this).next('.play-vortrag').css({'opacity':1})
    }, function () {
        $(this).next('.play-vortrag').css({'opacity':0.8})
        
    })


    /**
     * !Header Mobile lines width
     */
    function header4Lines() {
        var icon = $('#menu-mobile-icon')
        var svg_width = icon.find('svg').outerWidth()
        icon.css({'flex-basis':svg_width})
    }
    header4Lines()
    
    $(window).on('resize', function () {
        resizeLine()
        headerPadding()
        header4Lines()
        footerPadding()
    })

    var lastScrollTop = 0;
    var lastscrollTopMargin = $(window).height()/4
    var lastcrollUp = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            if(st < 100){
                return false;
            }
    
            $('#info-seite').addClass('hidden')
            lastcrollUp = 0
    
        } else {
    
            // upscroll code
            if(lastcrollUp == 0){
                lastcrollUp = lastScrollTop - lastscrollTopMargin
                if (lastcrollUp < 0) {
                    lastcrollUp = 0
                }
            }
            if(st < lastcrollUp){
                
                $('#info-seite').removeClass('hidden')
                lastcrollUp = 0
            }
        }
        lastScrollTop = st;
    });
})